import React from 'react'
import CardOil from '../../../components/Oil/CardOil/CardOil'
import style from './OilMenu.module.css'
import { useHistory } from "react-router-dom";
import { Translate } from "../../../language"
import TitleSVG from "../../../utils/components/TitleSVG/TitleSVG"

import { OilRecordIcon, OilIcon, OilRegisterIcon } from '../../../assets/icons';

const OilMenu = ({ litersReceived }) => {
  const history = useHistory();

  return (
    <div className={style.container_oil}>
      <TitleSVG Icon={OilIcon} titleHighlight={Translate('oilTitleHighlight', 'es')} title={Translate('oilTitle', 'es')} />

      <div className={style.container_options}>
        <div className={style.container_cards}>
          <CardOil
            text={Translate('registerText', 'es')}
            onClick={() => { history.push('/Oil/OilRegister') }}
            Icon={OilRegisterIcon}
          />

          <CardOil
            text={Translate('receptionRecords', 'es')}
            onClick={() => { history.push('/Oil/OilRecordEcoCEO') }}
            Icon={OilRecordIcon}
          />
        </div>

        <div
          className={style.text_oil}>{Translate('receivedOil', 'es')} <span className={style.text_highlight}>{litersReceived} L</span></div>
      </div>
    </div>
  )
}

export default OilMenu